<ctx-algolia-chemical-thumbnail [chemical]="chemical()" />

<div class="global-search-chemical__information">
	<p class="m-0">
		<tui-icon icon="@tui.flask-conical" />
		{{ chemical().name }}
	</p>

	@if (chemical().metadata.activeIngredient) {
		<small class="m-0">
			{{ chemical().metadata.activeIngredient }}
		</small>
	} @else {
		<small class="m-0">
			{{
				'data.last-edited-at'
					| transloco: { time: updatedAt() | relativeTime }
			}}
		</small>
	}
</div>
